<template>
  <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
    <el-breadcrumb-item v-for="(item)  in levelList" :key="item.path" v-if="item.path">
      <router-link :to="item.redirect||item.path">{{item.meta.title}}</router-link>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
    export default {
        name: "NavigationBar",
        data(){
           return {
             levelList:""
           }
        },
        methods:{
          getBreadcrumb() {
            var matched = this.$route.matched.filter(item => item.path);
            const first = matched[0];
            if (first && first.path !== '首页') {
              matched = [{path: '/home', meta: { title: '首页' }}].concat(matched);
            }
            this.levelList = matched;
          }
        },
       mounted(){
          this.getBreadcrumb();
       },
      watch:{
          $route(to,from){
            this.getBreadcrumb();
          }
      }
    }
</script>

<style scoped lang="less">
 .breadcrumb{
    width: 1240px;
     margin: 0px auto;
     padding-top: 68px;
     height: 44px;
 }
 .router-link-exact-active{

 }
 .el-breadcrumb__inner{
   a{
     font-size:14px;
     font-weight:400;
     color:rgba(191,191,191,1);
     line-height:18px;
   }
 }
 .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
   font-size:14px;
   font-weight:400;
   color:rgba(51,51,51,1);
   line-height:18px;
 }

</style>
